import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=e9b07ccc&scoped=true&"
import script from "./baseInfo.vue?vue&type=script&lang=js&"
export * from "./baseInfo.vue?vue&type=script&lang=js&"
import style0 from "./baseInfo.vue?vue&type=style&index=0&id=e9b07ccc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b07ccc",
  null
  
)

export default component.exports